import React from "react";
import {PktAlert} from "@oslokommune/punkt-react";
import styles from "./alerts.module.scss";

export const AlertError = () => (
    <PktAlert className={styles.alert} skin={"error"}>
        Det er en feil i systemet vårt. Vi jobber med å fikse den. Vennligst prøv på
        nytt litt senere.
    </PktAlert>
);

